import { all, fork, put, select, takeLatest } from 'redux-saga/effects';
import { showToastAlert } from '../app';
import {
  ACTION_DELETE_TREASURE,
  ACTION_FETCH_LIST_TREASURE,
  ACTION_UPDATE_FILTER_TREASURE,
  deleteTreasureAPI,
  getListTreasureAPI,
  REQUEST_DELETE_TREASURE_FAILURE,
  REQUEST_DELETE_TREASURE_SUCCESS,
} from './index';

function* loadRouteData() {
  const { treasureManagement } = yield select();
  const { treasureFilter } = treasureManagement;
  yield put(getListTreasureAPI(treasureFilter));
}

function* handleListenActions() {
  yield takeLatest([ACTION_FETCH_LIST_TREASURE, ACTION_UPDATE_FILTER_TREASURE], function* () {
    const { treasureManagement } = yield select();
    const { treasureFilter } = treasureManagement;
    yield put(getListTreasureAPI(treasureFilter));
  });

  yield takeLatest([ACTION_DELETE_TREASURE], function* (action) {
    yield put(deleteTreasureAPI(action?.payload));
  });

  yield takeLatest([REQUEST_DELETE_TREASURE_SUCCESS], function* (_action) {
    const { treasureManagement } = yield select();
    const { treasureFilter } = treasureManagement;
    yield put(showToastAlert('Delete treasure successfully'));
    yield put(getListTreasureAPI(treasureFilter));
  });

  yield takeLatest([REQUEST_DELETE_TREASURE_FAILURE], function* (action) {
    const errorMessage = action?.payload?.data?.message || 'Delete treasure failed';
    yield put(showToastAlert(errorMessage, 'error'));
  });
}

export function* loadTreasureManagementPage() {
  yield all([fork(loadRouteData), fork(handleListenActions)]);
}
